/**
 * Milliseconds on a clock that a system clock correction cannot move.
 *
 * Firefox exposes `performance` as null when `dom.enable_performance` is off, so
 * the global is read on each call and Date.now() stands in when it is unusable.
 */
export function monotonicNow() {
    const clock = globalThis.performance;
    return typeof clock?.now === 'function' ? clock.now() : Date.now();
}
